import { connect } from 'react-redux';
import CRUDActions from '../../../actions/player';
import PlayersNew from './PlayersEdit';


export default connect(
  ({player: {loadingItem, model}}) => ({
    title: 'Edit Player',
    loading: loadingItem,
    model,
    initialValues: Object.assign({}, model)
  }),
  dispatch => ({
    fetch: ({id}) => dispatch(CRUDActions.fetch(id))
  })
)(PlayersNew);



// WEBPACK FOOTER //
// ./src/components/Players/PlayersEdit/index.js